import React, { useEffect, useState } from 'react'
import './index.scss'
import { useLocation } from 'react-router'
import ModalPortal from '@Components/Popups/ModalPortal'
import WelcomePopup from '@Components/Popups/WelcomePopup'
import clsx from 'clsx'
import HelpMenuClickable from '@Components/Navigations/HelpMenu/HelpMenuClickable'
import HelpMenuPopover from '@Components/Navigations/HelpMenu/HelpMenuPopover'
import MlcPopoverMenu from '@Components/Tooltips/MlcPopoverMenu'

const HelpMenu = () => {
    const location = useLocation()
    const [popoverOpen, setPopoverOpen] = useState<boolean>(false)
    const [onBoardingPopupIsOpen, setOnBoardingPopupIsOpen] = useState<boolean>(false)

    const handleClick = () => {
        setPopoverOpen(!popoverOpen)
    }

    const closePopover = () => {
        setPopoverOpen(false)
    }

    const onOpenOnBoardingPopup = () => {
        closePopover()
        setOnBoardingPopupIsOpen(true)
    }

    useEffect(() => {
        closePopover()
    }, [location])

    const classNames = clsx('help-menu-component', 'icon-button', popoverOpen && 'active')
    const helpMenuId = 'helpMenuId'

    return (
        <>
            <MlcPopoverMenu
                clickableComponent={<HelpMenuClickable />}
                menuComponent={<HelpMenuPopover onOpenOnBoardingPopup={onOpenOnBoardingPopup} />}
                closeMenu={closePopover}
                classNames={classNames}
                dataTooltipId={helpMenuId}
                handleClick={handleClick}
                popoverOpen={popoverOpen}
                title="Help"
                dataTestId="help-menu"
            />
            <ModalPortal isOpen={onBoardingPopupIsOpen} onClose={() => setOnBoardingPopupIsOpen(false)}>
                <WelcomePopup onClose={() => setOnBoardingPopupIsOpen(false)} />
            </ModalPortal>
        </>
    )
}

export default HelpMenu
